import { Button } from '@britishcouncil/react-extro-ui';
import styled from '@emotion/styled';

export const Root = styled(Button)`
  padding-inline-start: 0;
`;
